import { configureStore } from "@reduxjs/toolkit";

import foodReducer from "../views/food/slice/foodSlice";
import quantityUnitSlice from "../views/quantity-units/slice/quantityUnitSlice";
import unitMeasurementsReducer from "../views/unit-measurements/slice/unitMeasurementsSlice";
import dietModelReducer from "../views/diet-model/slice/dietModelSlice";
// import kidneyReducer from "../views/kidney-failure/slice/kidneySlice";

export const store = configureStore({
  reducer: {
    food: foodReducer,
    quantityUnit: quantityUnitSlice,
    unitMeasurements: unitMeasurementsReducer,
    dietModel: dietModelReducer
    // kidney: kidneyReducer
  }
});
